import type { AppRouteRecordRaw } from "#src/router/types";

import { IconReader } from "#src/components/iconReader/IconReader";
import ContainerLayout from "#src/layout/container-layout";
import { createElement, lazy } from "react";

const StockPage = lazy(() => import("#src/features/Stocks"));
const InventoryPage = lazy(() => import("#src/features/Inventory"));
const TransactionsPage = lazy(() => import("#src/features/Transactions"));

const routes: AppRouteRecordRaw[] = [
	{
		path: "/stock",
		Component: ContainerLayout,
		handle: {
			title: "Stock & Inventory",
			icon: createElement(IconReader as any, { name: "inventory" }),
			order: 4,
			keepAlive: true,
		},
		children: [
			{
				path: "/stock/items",
				Component: StockPage,
				handle: { title: "Stock Items" },
			},
			{
				path: "/stock/inventory",
				Component: InventoryPage,
				handle: { title: "Inventory" },
			},
			{
				path: "/stock/transactions",
				Component: TransactionsPage,
				handle: { title: "Transactions" },
			},
		],
	},
];

export default routes;
